import type { ServiceConversationActivity, ServiceThread, ServiceTicket } from "@rakazo/contracts";
import { Button } from "@rakazo/ui-web";
import { ArrowUpRight } from "lucide-react";
import { CallRecording } from "./CallRecording";
import { TICKET_CHANNELS } from "./TicketChannels";

export function CustomerConversationCard({
  activity,
  ticket,
  thread,
  onOpen,
  preview = false,
}: {
  activity: ServiceConversationActivity;
  ticket: ServiceTicket;
  thread: ServiceThread;
  onOpen: () => void;
  preview?: boolean;
}) {
  const { Icon } = TICKET_CHANNELS[thread.channel];
  const active = activity.state === "active" && ticket.lifecycle === "active";
  const status =
    ticket.lifecycle === "closed"
      ? "Closed"
      : !active
        ? thread.channel === "call"
          ? "Call ended"
          : "Conversation ended"
        : thread.channel === "call"
          ? "Live call"
          : thread.channel === "chat"
            ? "Live chat"
            : thread.channel === "text"
              ? "Live SMS"
              : "Replying";
  return (
    <div className="w-full max-w-[39rem]">
      <Button
        variant="outline"
        className="mt-1 mb-4 h-auto w-full max-w-[39rem] justify-start gap-3 rounded-xl p-4 text-start whitespace-normal"
        aria-label={`Open ticket ${ticket.id} from ${thread.label}, ${ticket.customer}`}
        data-testid={`conversation-card-${ticket.id}-${thread.id}`}
        onClick={onOpen}
      >
        <Icon className="shrink-0 text-muted-foreground" />
        <span className="min-w-0 flex-1">
          <span className="block text-body2 font-medium">{ticket.customer}</span>
          <span className="mt-1 block text-label font-normal text-muted-foreground">
            {ticket.subject}
          </span>
          <span className="mt-2 block text-caption font-normal text-muted-foreground">
            {thread.label} · Ticket #{ticket.id} ·{" "}
            {ticket.lifecycle === "active" ? "Active" : "Closed"}
          </span>
        </span>
        <span
          className={`shrink-0 text-caption font-normal ${active ? "text-success" : "text-muted-foreground"}`}
        >
          {status}
        </span>
        <ArrowUpRight className="shrink-0 text-muted-foreground" />
      </Button>
      {thread.channel === "call" ? (
        <CallRecording ticketId={ticket.id} thread={thread} preview={preview} />
      ) : null}
    </div>
  );
}
